import Property, { IProperty } from "@/components/Property";
import { WithClassName } from "@/types/base";
import { AI_Params_Words, useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { observer } from "mobx-react-lite";
import React from "react";

const Input: React.FC<
  {
    identifier: string;
    word: AI_Params_Words | Editor_Words;
    value: any;
    setValue: (value: any) => void;
  } & IProperty<string | number>
> = ({ identifier, word, value, setValue, ...propertyProps }) => {
  const { translate } = useTranslate();
  return (
    <Property
      h="32px"
      mt="4px"
      identifier={identifier}
      text={translate(word)}
      value={value}
      setValue={setValue}
      {...propertyProps}
    />
  );
};

export const InputField = observer(Input);
